<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import StockMovementForm from "./components/StockMovementForm.vue"

defineProps<{
  stock_movement: {
    id: number
    company_id: number | ""
    product_id: number | ""
    movement_type: string
    reason: string
    notes: string
    quantity: string
    unit_cost_cents: string
    reference_type: string
    reference_id: string
  }
  companies: Array<{ id: number; name: string }>
  products: Array<{ label: string; value: number }>
  movement_types: Array<{ label: string; value: string }>
  reason_options: Array<{ label: string; value: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <StockMovementForm
      mode="edit"
      title="StockMovements/StockMovementsEdit"
      subtitle="Atualize os dados da movimentacao de estoque."
      :stock-movement="stock_movement"
      :companies="companies"
      :products="products"
      :movement-types="movement_types"
      :reason-options="reason_options"
      :errors="errors"
    />
  </AppShell>
</template>

